import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BannerProvider } from "./components/common/BannerContext"; // Import BannerProvider
import MockPrintView from "./components/features/Study/MockPrintView";
import { FeatureFlagProvider } from "./context/FeatureFlagContext";
import { TenantEntitlementsProvider } from "./context/TenantEntitlementsContext";
import { GuidedTourProvider } from "./components/common/tours/GuidedTourProvider";

// Disable console output in production for security
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
      {window.location.pathname.startsWith('/print/') ? (
        <Routes>
          <Route path="/print/mock/:paperId" element={<MockPrintView />} />
        </Routes>
      ) : (
        <FeatureFlagProvider>
          <GuidedTourProvider>
            <TenantEntitlementsProvider>
              <BannerProvider>
                <App />
              </BannerProvider>
            </TenantEntitlementsProvider>
          </GuidedTourProvider>
        </FeatureFlagProvider>
      )}
    </BrowserRouter>
);